<template>
  <main>
    <div class="navbar nav-daftar">
      <div>
        <div class="logo">
          <img src="https://pendaftaran.pspp-integrated.com/v2/assets/img/logo.png">
        </div>
      </div>
    </div>
    <div class="pendaftaran">
      <SyaratDaftar v-if="!setuju" @lanjut="setuju = true" />
      <div class="form" v-if="setuju">
        <div>
          <h3>Pendaftaran Siswa Baru</h3>
          <p style="margin-bottom: 60px;">
            Lengkapi data pendaftaran di bawah ini dengan baik dan benar sesuai dengan data diri Anda.
          </p>
          <div class="home fade-up">
            <form autocomplete="off" @submit.prevent="daftar()">
              <div class="group">
                <h3>Pilih Kampus & Jurusan</h3>
                <div class="grid">
                  <div class="form-group">
                    <label>Kampus <small v-if="submit && !data.id_kampus_2">- Harus diisi</small></label>
                    <select v-model="data.id_kampus_2" :class="{ 'invalid': submit && !data.id_kampus_2 }">
                      <option :value="item.id" v-for="(item, index) in param.kampus" :key="index">
                        {{ item.nama }}
                      </option>
                    </select>
                  </div>

                  <div class="form-group">
                    <label>Angkatan Pendidikan <small v-if="submit && !data.angkatan_2">- Harus
                        diisi</small></label>
                    <select v-model="data.angkatan_2" :class="{ 'invalid': submit && !data.angkatan_2 }">
                      <option :value="item.angkatan" v-for="(item, index) in param.angkatan_pendaftaran" :key="index">
                        {{ item.angkatan }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="grid">
                  <div class="form-group">
                    <label>Pilih Jurusan <small v-if="submit && !data.jurusan">- Harus
                        diisi</small></label>

                    <select v-model="data.jurusan" :class="{ 'invalid': submit && !data.jurusan }"
                      @change="validatePse()">
                      <option value="-1" v-if="!data.id_kampus_2">-- Pilih kampus terlebih dahulu --</option>
                      <option v-for="item, index in jurusanPerKampus[data.id_kampus_2]" :value="item" :key="index">
                        {{ item }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label>
                      {{ data.jurusan == 'STAFF LOADING UNLOADING' ? 'Pilih Paket' : 'Pilih Program' }} <small
                        v-if="submit && !data.program">- Harus
                        diisi</small>
                    </label>

                    <select v-model="data.program" :class="{ 'invalid': submit && !data.program }"
                      v-if="data.jurusan != 'STAFF LOADING UNLOADING'">
                      <option value="REGULER">
                        Reguler
                      </option>
                      <option value="INTERNASIONAL" v-if="data.jurusan != 'PREMIUM SERVICE EXCELLENT'">
                        Internasional
                      </option>
                    </select>

                    <select v-model="data.program" :class="{ 'invalid': submit && !data.program }"
                      v-if="data.jurusan == 'STAFF LOADING UNLOADING'">
                      <option value="REGULER">
                        Reguler
                      </option>
                      <option value="JAMINAN KERJA">
                        Jaminan Kerja
                      </option>
                    </select>
                  </div>
                </div>

                <!-- <div class="form-group" v-if="data.program == 'INTERNASIONAL'">
                  <label>Apakah Anda tertarik mengikuti seleksi masuk Kelas Prioritas jaminan Kerja?
                    <small v-if="submit && data.program == 'INTERNASIONAL' && !data.tertarik_kelas_prioritas">- Harus diisi</small></label>

                  <select v-model="data.tertarik_kelas_prioritas"
                    :class="{ 'invalid': submit && data.program == 'INTERNASIONAL' && !data.tertarik_kelas_prioritas }">
                    <option value="YA">
                      Ya, saya siap ikut seleksi karena dijamin Kerja
                    </option>
                    <option value="TIDAK">
                      Tidak, saya ikut Kelas Basic International saja
                    </option>
                  </select>
                </div> -->

              </div>

              <div class="group">
                <h3>Data Diri</h3>
                <div class="form-group">
                  <label>Nama Lengkap (Sesuai Identitas / tidak disingkat) <small v-if="submit && !data.nama_lengkap">-
                      Harus diisi</small></label>
                  <input type="text" v-uppercase v-model="data.nama_lengkap"
                    :class="{ 'invalid': submit && !data.nama_lengkap }">
                </div>

                <div class="grid">
                  <div class="form-group">
                    <label>Nama Panggilan <small v-if="submit && !data.nama_panggilan">- Harus
                        diisi</small></label>
                    <input type="text" v-uppercase v-model="data.nama_panggilan"
                      :class="{ 'invalid': submit && !data.nama_panggilan }">
                  </div>

                  <div class="form-group">
                    <label>Jenis Kelamin <small v-if="submit && !data.jenis_kelamin">- Harus
                        diisi</small></label>
                    <select v-model="data.jenis_kelamin" :class="{ 'invalid': submit && !data.jenis_kelamin }">
                      <option value="Laki-laki">Laki-laki</option>
                      <option value="Perempuan">Perempuan</option>
                    </select>
                  </div>
                </div>
                <div class="form-group">
                  <label>Tempat lahir <small v-if="submit && !data.tempat_lahir">- Harus
                      diisi</small></label>
                  <input type="text" v-model="data.tempat_lahir" v-uppercase
                    :class="{ 'invalid': submit && !data.tempat_lahir }">
                </div>
                <div class="form-group">
                  <label>Tgl lahir
                    <small v-if="submit && !data.tgl_lahir && !data.bln_lahir && !data.thn_lahir">
                      - Harus
                      diisi
                    </small>
                    <small
                      v-if="submit && ((parseInt(data.tgl_lahir) > 31) || (parseInt(data.thn_lahir) < 1990 || parseInt(data.thn_lahir) > 2023))">
                      - Tgl lahir tidak valid
                    </small>
                  </label>
                  <div class="tgl-lahir">
                    <input type="number" v-model="data.tgl_lahir" placeholder="Tgl"
                      :class="{ 'invalid': submit && !data.tgl_lahir }">
                    <select v-model="data.bln_lahir" :class="{ 'invalid': submit && !data.bln_lahir }">
                      <option :value="index" v-for="item, index in bulanLahir">{{ item }}</option>
                    </select>
                    <input type="number" v-model="data.thn_lahir" placeholder="Tahun"
                      :class="{ 'invalid': submit && !data.thn_lahir }">
                  </div>
                </div>

                <div class="grid">
                  <div class="form-group">
                    <label>Tinggi badan (dalam cm) <small v-if="submit && !data.tinggi_badan">- Harus
                        diisi</small></label>
                    <input type="number" v-model="data.tinggi_badan"
                      :class="{ 'invalid': submit && !data.tinggi_badan }">
                  </div>
                  <div class="form-group">
                    <label>Berat badan (dalam kg) <small v-if="submit && !data.berat_badan">- Harus
                        diisi</small></label>
                    <input type="number" v-model="data.berat_badan" :class="{ 'invalid': submit && !data.berat_badan }">
                  </div>
                </div>
                <div class="grid">
                  <div class="form-group">
                    <label>Ukuran Baju <small v-if="submit && !data.ukuran_baju">- Harus
                        diisi</small></label>
                    <select v-model="data.ukuran_baju">
                      <option value="M">M</option>
                      <option value="L">L</option>
                      <option value="XL">XL</option>
                      <option value="XXL">XXL</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label>Ukuran Sepatu <small v-if="submit && !data.ukuran_sepatu">- Harus
                        diisi</small></label>
                    <select v-model="data.ukuran_sepatu">
                      <option value="37">37</option>
                      <option value="38">38</option>
                      <option value="39">39</option>
                      <option value="40">40</option>
                      <option value="41">41</option>
                      <option value="42">42</option>
                      <option value="43">43</option>
                      <option value="44">44</option>
                    </select>
                  </div>
                </div>
                <div class="grid" v-show="data.jenis_kelamin == 'Perempuan'">
                  <div class="form-group">
                    <label>Jilbab</label>
                    <select v-model="data.jilbab">
                      <option value="YA">Ya</option>
                      <option value="TIDAK">Tidak</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="group">
                <h3>Kontak</h3>
                <div class="grid">
                  <div class="form-group no-hp">
                    <label>No Whatsapp <small v-if="submit && !data.no_hp_siswa">- Harus
                        diisi</small></label>
                    <span>
                      +62
                    </span>
                    <input type="tel" v-model="data.no_hp_siswa" v-nohp
                      :class="{ 'invalid': submit && !data.no_hp_siswa }">
                  </div>
                  <div class="form-group no-hp">
                    <label>No Whatsapp Orangtua <small v-if="submit && !data.no_hp_orangtua">- Harus
                        diisi</small></label>
                    <span>
                      +62
                    </span>
                    <input type="tel" v-model="data.no_hp_orangtua" v-nohp
                      :class="{ 'invalid': submit && !data.no_hp_orangtua }">
                  </div>
                </div>

                <div class="form-group">
                  <label>Email <small v-if="submit && !data.email">- Harus
                      diisi</small></label>
                  <input type="email" v-model="data.email" :class="{ 'invalid': submit && !data.email }">
                </div>
                <div class="form-group">
                  <label>Alamat lengkap (Sesuai Identitas) <small v-if="submit && !data.alamat_siswa">-
                      Harus
                      diisi</small></label>
                  <textarea rows="4" v-model="data.alamat_siswa" v-uppercase
                    :class="{ 'invalid': submit && !data.alamat_siswa }"></textarea>
                </div>

                <!-- :className="submit && !data.berkas_foto_selfie ? 'invalid' : ''" -->
                <!-- <ImageUpload endpoint="https://api.psppcdn.com/v1/berkas/upload_file"
                  @uploaded="(url) => handleUploaded(url, 'berkas_foto_selfie')" label="Upload foto terbaru" />
                <small><i>- Max 2MB</i></small><br />
                <small><i>- Format file direkomendasikan jpg, png</i></small> -->

                <div class="form-group" style="margin-top: 15px;">
                  <label>Tahu informasi PSPP dari mana?</label>
                  <select v-model="data.sumber_informasi_pspp">
                    <option value="">-- Pilih salah satu --</option>
                    <option value="instagram">Instagram</option>
                    <option value="tiktok">TikTok</option>
                    <option value="facebook">Facebook</option>
                    <option value="youtube">YouTube</option>
                    <option value="website">Website PSPP</option>
                    <option value="google">Google / Mesin Pencari</option>
                    <option value="teman">Teman / Keluarga</option>
                    <option value="alumni">Alumni PSPP</option>
                    <option value="iklan">Iklan Online</option>
                    <option value="brosur">Brosur / Spanduk</option>
                    <option value="pameran">Pameran Pendidikan</option>
                    <option value="whatsapp">WhatsApp</option>
                    <option value="lainnya">Lainnya</option>
                  </select>
                </div>
              </div>

              <p>
                <i>
                  <small>
                    Sumber Informasi : {{ data.domain_marketing }} ({{ data.nama_marketing }})
                  </small>
                </i>
              </p>

              <div class="form-group">
                <label class="checkbox" :class="{ 'invalid': submit && !data.setuju }">
                  <input type="checkbox" v-model="data.setuju">
                  Saya menyetujui dan bertanggung jawab atas data yang saya isi dan dapat sudah sesuai dengan syarat
                  masuk PSPP Penerbangan.
                </label>
              </div>
              <div class="btn-group">
                <button type="button" class="btn btn-primary btn-daftar" @click="daftar()"
                  :disabled="loadingDaftar">DAFTAR SEKARANG</button>
              </div>
              <p class="login">
                <router-link to="/login">
                  Sudah punya akun? <b>Login</b>
                </router-link>
              </p>
            </form>
          </div>
        </div>
      </div>
      <div class="loading" v-if="loadingDaftar">
        <div class="spinner"></div>
      </div>
    </div>

    <div class="modal" v-if="modalOpen != ''" @click="closeModal">
      <div class="modal-body" v-if="modalOpen == 'syarat'">

      </div>

      <div class="modal-body" v-if="modalOpen == 'kelas-internasional'">
        <h3>Kelas Internasional</h3>

        <ul class="tab">
          <li @click="tab = 'staff'" :class="{ active: tab == 'staff' }">Staff Penerbangan</li>
          <li @click="tab = 'pramugari'" :class="{ active: tab == 'pramugari' }">Pramugari</li>
          <li @click="tab = 'avsec'" :class="{ active: tab == 'avsec' }">Aviation Security</li>
        </ul>

        <table v-if="tab == 'staff'">
          <thead>
            <tr>
              <th>Fitur Program</th>
              <th>PSPP Reguler</th>
              <th>PSPP Internasional</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Durasi Pendidikan</td>
              <td>3 bulan teori + 2 bulan PKL</td>
              <td>3 bulan teori + 2 bulan PKL</td>
            </tr>
            <tr>
              <td>Kelas Prioritas (Jaminan kerja)</td>
              <td>❌ Tidak tersedia</td>
              <td>✅ Syarat mengikuti prioritas (Jaminan Kerja)</td>
            </tr>
            <tr>
              <td>International Study Tour</td>
              <td>❌ Tidak tersedia</td>
              <td>✅ Singapura (kunjungan & eksplorasi industri)</td>
            </tr>
            <tr>
              <td>Local Guide (Foreign Speaker)</td>
              <td>❌ Tidak tersedia</td>
              <td>✅ Disediakan (English exposure & culture session)</td>
            </tr>
            <tr>
              <td>Kunjungan Perusahaan Penerbangan</td>
              <td>❌ Tidak tersedia</td>
              <td>✅ Kunjungan ke perusahaan penerbangan/transportasi</td>
            </tr>
            <tr>
              <td>Kuliah Umum</td>
              <td>❌ Tidak tersedia</td>
              <td>✅ Dari dunia aviasi, kereta api, hotel, dan perbankan</td>
            </tr>
            <tr>
              <td>BNSP (Sertifikasi Profesi)</td>
              <td>❌ Tidak tersedia</td>
              <td>✅ Sertifikasi Profesi</td>
            </tr>
            <tr>
              <td>Bursa Kerja</td>
              <td>✅ Tersedia</td>
              <td>✅ Tersedia</td>
            </tr>
            <tr>
              <td>Local Tour & airport visit</td>
              <td>✅ Tersedia</td>
              <td>✅ Tersedia</td>
            </tr>
            <tr>
              <td>Wisuda</td>
              <td>✅ Tersedia</td>
              <td>✅ Tersedia</td>
            </tr>
            <tr>
              <td>Biaya Pendidikan</td>
              <td>Lebih ekonomis</td>
              <td>Lebih premium, sesuai fasilitas tambahan</td>
            </tr>
            <tr>
              <td>Kelas & Materi</td>
              <td>Standar Nasional</td>
              <td>Standar Nasional + Materi Karier Global</td>
            </tr>
            <tr>
              <td>Sertifikat Tambahan</td>
              <td>Sertifikat PSPP</td>
              <td>PSPP + Sertifikat Kegiatan Internasional</td>
            </tr>
            <tr>
              <td>Kuota Peserta</td>
              <td>Lebih banyak</td>
              <td>Terbatas per gelombang</td>
            </tr>
            <tr>
              <td>Cocok untuk siapa?</td>
              <td>Peserta yang ingin mulai karier domestik</td>
              <td>Peserta yang ingin pengalaman & peluang lebih luas</td>
            </tr>
          </tbody>
        </table>

        <table v-if="tab == 'pramugari'">
          <thead>
            <tr>
              <th>Fitur Program</th>
              <th>PSPP Reguler</th>
              <th>PSPP Internasional</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Durasi Pendidikan</td>
              <td>3 bulan teori + 2 bulan PKL</td>
              <td>3 bulan teori + 2 bulan PKL</td>
            </tr>
            <tr>
              <td>Kelas Prioritas (Jaminan kerja)</td>
              <td>❌ Tidak tersedia</td>
              <td>✅ Syarat mengikuti prioritas (Jaminan Kerja)</td>
            </tr>
            <tr>
              <td>International Study Tour</td>
              <td>❌ Tidak tersedia</td>
              <td>✅ Singapura (kunjungan & eksplorasi industri)</td>
            </tr>
            <tr>
              <td>Local Guide (Foreign Speaker)</td>
              <td>❌ Tidak tersedia</td>
              <td>✅ Disediakan (English exposure & culture session)</td>
            </tr>
            <tr>
              <td>Kunjungan Perusahaan Penerbangan</td>
              <td>❌ Tidak tersedia</td>
              <td>✅ Kunjungan ke perusahaan penerbangan/transportasi</td>
            </tr>
            <tr>
              <td>Kuliah Umum</td>
              <td>❌ Tidak tersedia</td>
              <td>✅ Dari dunia aviasi, kereta api, hotel, dan perbankan</td>
            </tr>
            <tr>
              <td>BNSP (Sertifikasi Profesi)</td>
              <td>❌ Tidak tersedia</td>
              <td>✅ Sertifikasi Profesi</td>
            </tr>
            <tr>
              <td>Mockup Wetdrill Practical</td>
              <td>✅ Tersedia: Teori</td>
              <td>✅ Tersedia: Praktik (NAM TC)</td>
            </tr>
            <tr>
              <td>Table Manner Practical</td>
              <td>✅ Tersedia</td>
              <td>✅ Tersedia</td>
            </tr>
            <tr>
              <td>Bursa Kerja</td>
              <td>✅ Tersedia</td>
              <td>✅ Tersedia</td>
            </tr>
            <tr>
              <td>Local Tour & airport visit</td>
              <td>✅ Tersedia</td>
              <td>✅ Tersedia</td>
            </tr>
            <tr>
              <td>Wisuda</td>
              <td>✅ Tersedia</td>
              <td>✅ Tersedia</td>
            </tr>
            <tr>
              <td>Biaya Pendidikan</td>
              <td>Lebih ekonomis</td>
              <td>Lebih premium, sesuai fasilitas tambahan</td>
            </tr>
            <tr>
              <td>Kelas & Materi</td>
              <td>Standar Nasional</td>
              <td>Standar Nasional + Materi Karier Global</td>
            </tr>
            <tr>
              <td>Sertifikat Tambahan</td>
              <td>Sertifikat PSPP</td>
              <td>PSPP + Sertifikat Kegiatan Internasional</td>
            </tr>
            <tr>
              <td>Kuota Peserta</td>
              <td>Lebih banyak</td>
              <td>Terbatas per gelombang</td>
            </tr>
            <tr>
              <td>Cocok untuk siapa?</td>
              <td>Peserta yang ingin mulai karier domestik</td>
              <td>Peserta yang ingin pengalaman & peluang lebih luas</td>
            </tr>
          </tbody>
        </table>

        <table v-if="tab == 'avsec'">
          <thead>
            <tr>
              <th>Fitur Program</th>
              <th>PSPP Reguler</th>
              <th>PSPP Internasional</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Durasi Pendidikan</td>
              <td>3 bulan teori + 2 bulan PKL</td>
              <td>3 bulan teori + 2 bulan PKL</td>
            </tr>
            <tr>
              <td>Kelas Prioritas (Jaminan kerja)</td>
              <td>❌ Tidak tersedia</td>
              <td>✅ Syarat mengikuti prioritas (Jaminan Kerja)</td>
            </tr>
            <tr>
              <td>International Study Tour</td>
              <td>❌ Tidak tersedia</td>
              <td>✅ Singapura (kunjungan & eksplorasi industri)</td>
            </tr>
            <tr>
              <td>Local Guide (Foreign Speaker)</td>
              <td>❌ Tidak tersedia</td>
              <td>✅ Disediakan (English exposure & culture session)</td>
            </tr>
            <tr>
              <td>Kunjungan Perusahaan Penerbangan</td>
              <td>❌ Tidak tersedia</td>
              <td>✅ Kunjungan ke perusahaan penerbangan/transportasi</td>
            </tr>
            <tr>
              <td>Kuliah Umum</td>
              <td>❌ Tidak tersedia</td>
              <td>✅ Dari dunia aviasi, kereta api, hotel, dan perbankan</td>
            </tr>
            <tr>
              <td>BNSP (Sertifikasi Profesi)</td>
              <td>❌ Tidak tersedia</td>
              <td>✅ Sertifikasi Profesi</td>
            </tr>
            <tr>
              <td>Surat Tanda Kecakapan Personel (SKP AVSEC)</td>
              <td>✅ Tersedia</td>
              <td>✅ Tersedia</td>
            </tr>
            <tr>
              <td>Bursa Kerja</td>
              <td>✅ Tersedia</td>
              <td>✅ Tersedia</td>
            </tr>
            <tr>
              <td>Local Tour & airport visit</td>
              <td>✅ Tersedia</td>
              <td>✅ Tersedia</td>
            </tr>
            <tr>
              <td>Wisuda</td>
              <td>✅ Tersedia</td>
              <td>✅ Tersedia</td>
            </tr>
            <tr>
              <td>Biaya Pendidikan</td>
              <td>Lebih ekonomis</td>
              <td>Lebih premium, sesuai fasilitas tambahan</td>
            </tr>
            <tr>
              <td>Kelas & Materi</td>
              <td>Standar Nasional</td>
              <td>Standar Nasional + Materi Karier Global</td>
            </tr>
            <tr>
              <td>Sertifikat Tambahan</td>
              <td>Sertifikat PSPP</td>
              <td>PSPP + Sertifikat Kegiatan Internasional</td>
            </tr>
            <tr>
              <td>Kuota Peserta</td>
              <td>Lebih banyak</td>
              <td>Terbatas per gelombang</td>
            </tr>
            <tr>
              <td>Cocok untuk siapa?</td>
              <td>Peserta yang ingin mulai karier domestik</td>
              <td>Peserta yang ingin pengalaman & peluang lebih luas</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </main>
</template>

<script>

import { apiGet, apiPost } from '@/api'
import ImageUpload from '@/components/ImageUpload.vue';
import SyaratDaftar from '@/components/SyaratDaftar.vue';

export default {
  name: 'HomeView',
  components: { ImageUpload, SyaratDaftar },
  data() {
    return {
      setuju: false,

      loading: false,
      loadingKotaPendidikan: false,
      loadingSMA: false,
      loadingKabupaten: false,
      loadingKecamatan: false,
      loadingKelurahan: false,
      loadingDaftar: false,

      submit: false,
      tab: 'staff',
      modalOpen: '',

      data: {
        jurusan: '',
        jibab: 'TIDAK'
      },
      step: '1',

      param: {
        angkatan_pendaftaran: [],
      },
      kota_pendidikan: [],
      sma: [],
      kabupaten: [],
      kecamatan: [],
      kelurahan: [],

      agama: [
        'ISLAM', 'KATOLIK', 'KRISTEN', 'HINDU', 'BUDHA', 'LAINNYA'
      ],
      bulanLahir: [
        '',
        'JANUARI',
        'FEBRUARI',
        'MARET',
        'APRIL',
        'MEI',
        'JUNI',
        'JULI',
        'AGUSTUS',
        'SEPTEMBER',
        'OKTOBER',
        'NOVEMBER',
        'DESEMBER',
      ],
      jurusanPerKampus: {
        1: ['STAFF PENERBANGAN', 'PREMIUM SERVICE EXCELLENT'],
        2: ['PRAMUGARI', 'STAFF PENERBANGAN', 'PREMIUM SERVICE EXCELLENT'],
        3: ['PRAMUGARI', 'STAFF PENERBANGAN', 'PREMIUM SERVICE EXCELLENT', 'AVIATION SECURITY'],
        5: ['STAFF PENERBANGAN', 'PREMIUM SERVICE EXCELLENT', 'AVIATION SECURITY'],
      }
    }
  },

  methods: {
    closeModal(e) {
      if (e.target.classList[0] == 'modal') {
        this.modalOpen = '';
      }
    },
    async load() {
      const res = await apiGet('/v1/pendaftaran');
      this.param = res.data;
    },
    validatePse() {
      if (this.data.jurusan == 'PREMIUM SERVICE EXCELLENT') {
        this.data.program = 'REGULER'
      }
    },
    // toStep(step) {

    //   if (step >= 2) {
    //     this.submit = 'jurusan';

    //     if (!this.data.jurusan || !this.data.angkatan_2 || !this.data.id_kampus_2) {
    //       return;
    //     }

    //     this.$store.commit('siswa/setData', this.data)
    //   }
    //   if (step >= 3) {
    //     this.submit = 'biodata';

    //     if (
    //       !this.data.nama_lengkap ||
    //       !this.data.nama_panggilan ||
    //       !this.data.no_ktp ||
    //       !this.validKtp() ||
    //       !this.data.agama ||
    //       !this.data.jenis_kelamin ||
    //       !this.data.tempat_lahir ||
    //       !this.data.tgl_lahir || !this.data.bln_lahir || !this.data.thn_lahir ||
    //       !this.data.tinggi_badan || !this.data.berat_badan ||
    //       !this.data.ukuran_sepatu ||
    //       !this.data.ukuran_baju ||
    //       ((parseInt(this.data.tgl_lahir) > 31) || (parseInt(this.data.thn_lahir) < 1990 || parseInt(this.data.thn_lahir) > 2023))
    //     ) {
    //       return;
    //     }

    //     this.$store.commit('siswa/setData', this.data)
    //   }
    //   if (step >= 4) {
    //     this.submit = 'pendidikan';

    //     if (!this.data.provinsi_pendidikan || !this.data.kabupaten_pendidikan || !this.data.id_sekolah) {
    //       return;
    //     }

    //     this.$store.commit('siswa/setData', this.data)
    //   }

    //   setTimeout(() => {
    //     this.step = step;
    //   }, 150)
    // },
    convertStepToClass(step) {
      return {
        1: 'jurusan',
        2: 'biodata',
        3: 'pendidikan',
        4: 'kontak',
      }[step]
    },
    validEmail() {
      const re =
        /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

      return re.test(this.data.email)
    },
    validKtp() {
      return this.data.no_ktp && this.data.no_ktp.length >= 16;
    },
    handleUploaded(url, name) {
      this.data[name] = url
    },
    async daftar() {
      if (this.loadingDaftar) {
        return;
      }

      this.submit = true;

      if (
        !this.data.jurusan ||
        !this.data.angkatan_2 ||
        !this.data.id_kampus_2 ||
        !this.data.program ||

        !this.data.nama_lengkap ||
        !this.data.nama_panggilan ||
        !this.data.jenis_kelamin ||
        !this.data.tempat_lahir ||
        !this.data.tgl_lahir || !this.data.bln_lahir || !this.data.thn_lahir ||
        !this.data.tinggi_badan || !this.data.berat_badan ||

        !this.data.no_hp_siswa ||
        !this.data.alamat_siswa ||
        !this.data.no_hp_siswa ||

        // !this.data.berkas_foto_selfie ||
        !this.data.setuju
      ) {
        document.querySelector('.form').scrollTo({
          top: 0,
          behavior: 'smooth'
        });

        return;
      }

      this.$store.commit('siswa/setData', this.data)

      this.loadingDaftar = true;

      this.data.no_hp_siswa = this.data.no_hp_siswa.replace(/-/g, '')
      this.data.no_hp_orangtua = this.data.no_hp_orangtua.replace(/-/g, '')
      this.data.nama_lengkap = this.data.nama_lengkap.toUpperCase()
      this.data.nama_panggilan = this.data.nama_panggilan.toUpperCase()
      // this.data.nama_orangtua = this.data.nama_orangtua.toUpperCase()
      this.data.tempat_lahir = this.data.tempat_lahir.toUpperCase()

      try {
        const res = await apiPost('/v1/daftar', this.data)
        if (res.valid) {
          this.$store.commit('siswa/setData', res.data);
          alert('Pendaftaran Berhasil')
          this.$router.push('/')
        } else {
          console.log('err')
          alert('Terjadi kesalahan di server kami');
          this.loadingDaftar = false;
        }
      } catch (e) {
        console.log('e', e)
        alert('Terjadi kesalahan di server kami');
        this.loadingDaftar = false;
      }
    },

    async getKotaPendidikan() {
      this.loadingKotaPendidikan = true;

      const res = await apiGet(`/v1/sekolah/by-provinsi?provinsi=${this.data.provinsi_pendidikan}`);
      if (res.valid) {
        this.kota_pendidikan = res.data;

        this.loadingKotaPendidikan = false;
        this.$refs['select_kota'].focus();
      }
    },
    async getSMA() {
      this.loadingSMA = true;

      const res = await apiGet(`/v1/sekolah/by-kota?kota=${this.data.kabupaten_pendidikan}`);
      if (res.valid) {
        this.sma = res.data;

        this.loadingSMA = false;
        this.$refs['select_sma'].focus();
      }
    },

    async getKabupaten() {
      this.loadingKabupaten = true;

      const res = await apiGet(`/v1/alamat/kabupaten?id_provinsi=${this.data.id_provinsi}`);
      if (res.valid) {
        this.kabupaten = res.data;

        this.loadingKabupaten = false;
        this.$refs['select_kabupaten'].focus();
      }
    },
    async getKecamatan() {
      this.loadingKecamatan = true;

      const res = await apiGet(`/v1/alamat/kecamatan?id_kabupaten=${this.data.id_kabupaten}`);
      if (res.valid) {
        this.kecamatan = res.data;

        this.loadingKecamatan = false;
        this.$refs['select_kecamatan'].focus();
      }
    },
    async getKelurahan() {
      this.loadingKelurahan = true;

      const res = await apiGet(`/v1/alamat/kelurahan?id_kecamatan=${this.data.id_kecamatan}`);
      if (res.valid) {
        this.kelurahan = res.data;

        this.loadingKelurahan = false;
        this.$refs['select_kelurahan'].focus();
      }
    },
    async getMarketing(ref) {
      const r = await apiGet(`/v1/marketing?ref=${ref}`)
      if (r.valid) {
        const data = r.data;

        this.data.id_domain = data.id;
        this.data.id_marketing = data.id_marketing;
        this.data.domain_marketing = data.domain;
        this.data.nama_marketing = data.marketing;
        this.data.no_hp_marketing = data.no_hp_marketing;

        localStorage.setItem('x-app-marketing', JSON.stringify(data))
        this.$router.push('/daftar');

      } else {
        location.href = 'https://pspp-penerbangan.ac.id';
      }
    }
  },

  mounted() {
    this.load();
    if (this.$store.state.siswa && this.$store.state.siswa.data.jurusan) {
      this.data = this.$store.state.siswa.data;
    }

    if (this.$route.query && this.$route.query.ref) {
      this.getMarketing(this.$route.query.ref);
    } else {
      if (localStorage.getItem('x-app-marketing')) {
        const currentMarketing = JSON.parse(localStorage.getItem('x-app-marketing'));
        this.data.id_domain = currentMarketing.id;
        this.data.id_marketing = currentMarketing.id_marketing;
        this.data.domain_marketing = currentMarketing.domain;
        this.data.nama_marketing = currentMarketing.marketing;
        this.data.no_hp_marketing = currentMarketing.no_hp_marketing;
      } else {
        location.href = 'https://pspp-penerbangan.ac.id';
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar.nav-daftar {

  >div {
    display: flex;
    justify-content: space-between;
    max-width: 600px;
    margin: 0 auto;

    img {
      width: 120px;
    }

    ul {
      list-style: none;
      display: flex;
      gap: 15px;

      li {
        font-weight: normal;
        font-size: 14px;

        &:hover {
          color: var(--primary);
          cursor: pointer;
        }
      }
    }
  }
}

main {
  &::after {
    content: "";
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0px;
    // background-image: url('http://localhost:8080/pspp-logo.png');
    background-repeat: no-repeat;
    background-size: 800px;
    background-position: center center;
    opacity: 0.25;
    filter: blur(50px);
    z-index: -1;
  }
}

.grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
}

.pendaftaran {
  margin: 30px auto;
  position: relative;
}

.loading {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.5);
  display: flex;
  align-items: center;
}

.form {
  max-width: 600px;
  margin: 0 auto;
  padding: 0 20px;

  @media screen and (min-width: 768px) {
    padding: 0;
  }
}

.form-group {
  label {
    // font-weight: 500;
  }

  small {
    font-style: italic;
    color: red;
  }
}

.home {
  margin: 0 auto;
  background: #fff;
  border-radius: 6px;

  h3 {
    color: var(--primary-darker);
    font-weight: 500;
  }
}

.logo {
  text-align: center;

  img {
    width: 140px;

    @media screen and (min-width: 768px) {
      width: 200px;
    }
  }
}

.jurusan {
  border: 1px solid #ccc;
  border-radius: 6px;

  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;

    li {
      padding: 15px;
      border-bottom: 1px solid #ccc;
      display: flex;
      gap: 10px;
      align-items: center;
      transition: all 0.3s ease;
      font-size: 14px;
      cursor: pointer;

      &:active {
        background-color: #eee;
      }

      div {
        border: 1px solid #999;
        width: 15px;
        height: 15px;
        border-radius: 15px;
        display: flex;
        justify-content: center;
        align-items: center;

        &.active {
          span {
            display: block;
            width: 9px;
            height: 9px;
            border-radius: 9px;
            background-color: var(--primary);
          }
        }
      }
    }
  }
}

.step {
  margin: 30px 0;
  position: relative;

  .bar {
    width: 100%;
    height: 2px;
    background: #ccc;
    margin-top: 5px;

    span {
      display: block;
      height: 2px;
      background: var(--primary);
      transition: all 0.5s ease;
    }

    &.jurusan {
      border: 0;

      span {
        width: 25%;
      }
    }

    &.biodata {
      span {
        width: 50%;
      }
    }

    &.pendidikan {
      span {
        width: 75%;
      }
    }

    &.kontak {
      span {
        width: 100%;
      }
    }
  }

  ul {
    display: flex;
    list-style: none;
    justify-content: space-around;
    padding: 0;
    margin: 0;

    li {
      font-size: 13px;
      transition: all 0.5s ease;
      cursor: pointer;

      &.active {
        color: var(--primary);
      }

      @media screen and (min-width: 768px) {
        font-size: 14px;
      }
    }
  }
}

form {
  p {
    &.login {
      text-align: center;
      margin-top: 60px;
      font-size: 14px;

      a {
        color: #333;
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }

        b {
          color: var(--primary);
        }
      }
    }
  }

  .no-hp {
    position: relative;

    span {
      position: absolute;
      font-size: 14px;
      padding: 12px 10px;
      border-right: 1px solid #ccc;
    }

    input {
      padding-left: 55px;
      width: calc(100% - 74px);
    }
  }

  .nik {
    display: flex;
    gap: 10px;
  }

  .tgl-lahir {
    display: grid;
    grid-template-columns: 80px 1fr 100px;
    gap: 10px;
  }

  .jk {
    label {
      display: flex;
      align-items: center;
      gap: 5px;
      cursor: pointer;

      input {
        width: fit-content;
      }
    }
  }

  .cb {
    margin: 20px 0 30px;

    &.invalid {
      color: red;
      border: 0;

      label {
        border: 1px solid red;
      }
    }

    label {
      display: flex;
      font-size: 14px;
      cursor: pointer;

      input {
        width: fit-content;
      }
    }
  }
}

.tnc {
  h4 {
    font-weight: 500;
  }

  ol {
    li {
      font-size: 14px;
      padding: 2px 0;
    }
  }

  p {
    line-height: 20px;
    font-size: 14px;
  }
}

.invalid {
  border: 1px solid red;
}

.btn-daftar {
  @media screen and (max-width: 768px) {
    width: 100%;
  }
}

.modal {

  .modal-body {
    @media screen and (max-width: 768px) {
      width: calc(100% - 100px);
    }
  }

  h3 {
    font-weight: 500;
    margin: 0;
    font-size: 16px;
  }




  table {
    border-collapse: collapse;

    thead {
      tr {
        th {
          font-weight: 500;
          font-size: 14px;
          border: 1px solid #ccc;
          background: #eee;
          padding: 4px;
        }
      }
    }

    td {
      font-size: 14px;
      border: 1px solid #ccc;
      padding: 4px;
    }
  }
}
</style>
